import HTTP from '@/config/axios-config-erp'

const SrvArticulos = {
    // LISTA DE VALORES
    stockOrdenCompra(payload) {
        return HTTP.post(`/wscomun/portalinformes/stockArticulos`, payload).then(response => {
            if (response.status === 200) {
                return response
            } else {
                console.error(response)
                return response
            }
        }).catch(error => {
            return error
        })
    },
    stockCantidadExistente(payload) {
        return HTTP.post(`/wscomun/portalinformes/stockCantidadExistente`, payload).then(response => {
            if (response.status === 200) {
                return response
            } else {
                console.error(response)
                return response
            }
        }).catch(error => {
            return error
        })
    },
    getProximasRecepcionesOCProd(payload) {
        return HTTP.post(`/wscomun/portalinformes/getProximasRecepcionesOCProd`, payload).then(response => {
            if (response.status === 200) {
                return response
            } else {
                console.error(response)
                return response
            }
        }).catch(error => {
            return error
        })
    },
    getUrlImgArt(payload) {
        return HTTP.post(`/wscomun/portalinformes/getUrlImgArt`, payload).then(response => {
            
            if (response.status === 200) {
                return response
            } else {
                console.error(response)
                return response
            }
        }).catch(error => {
            return error
        })
    }
}

export default SrvArticulos



// WEBPACK FOOTER //
// ./src/services/srv-articulos.js